import { render, staticRenderFns } from "./pageNotfound.vue?vue&type=template&id=1bcf622b&"
import script from "./pageNotfound.vue?vue&type=script&lang=js&"
export * from "./pageNotfound.vue?vue&type=script&lang=js&"
import style0 from "./pageNotfound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports